/* Waka Classics — rieles, pestañas, paneles, carro y ficha.
   OJO: el filtro de género vive SOLO en waka-nav.js. Antes estaba en los dos
   archivos y se pisaban entre sí (uno con display inline, el otro con clase). */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};

  function syncArrows(){
    $$('[data-rail-wrap]').forEach(function(sec){
      var rail=sec.querySelector('[data-rail]'), b=$$('[data-rail-prev],[data-rail-next]',sec);
      if(!rail||b.length<2)return;
      var max=rail.scrollWidth-rail.clientWidth-2;
      b[0].disabled=rail.scrollLeft<=2;
      b[1].disabled=rail.scrollLeft>=max;
    });
  }
  window.WAKA_SYNC_ARROWS=syncArrows;

  $$('[data-rail-wrap]').forEach(function(sec){
    var rail=sec.querySelector('[data-rail]');
    if(!rail)return;
    var step=function(){return rail.clientWidth*0.75};
    var p=sec.querySelector('[data-rail-prev]'), n=sec.querySelector('[data-rail-next]');
    if(p)p.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'})});
    rail.addEventListener('scroll',syncArrows);
  });
  window.addEventListener('resize',syncArrows);

  $$('[data-tabs]').forEach(function(tabs){
    var pane=document.getElementById(tabs.getAttribute('data-tabs'));
    if(!pane)return;
    function show(k){
      $$('[data-tab-item]',pane).forEach(function(c){
        c.style.display=(c.getAttribute('data-tab-item')||'').split(' ').indexOf(k)>-1?'':'none';
      });
      pane.scrollLeft=0; syncArrows();
    }
    tabs.addEventListener('click',function(e){
      var b=e.target.closest('button[data-tab]'); if(!b)return;
      $$('button',tabs).forEach(function(x){x.classList.remove('act')});
      b.classList.add('act'); show(b.getAttribute('data-tab'));
    });
    var first=tabs.querySelector('button.act')||tabs.querySelector('button[data-tab]');
    if(first)show(first.getAttribute('data-tab'));
  });

  var R=window.WAKA_ROUTES||{cart:'/cart',add:'/cart/add',change:'/cart/change',predictive:'/search/suggest'};
  var scrim=$('#scrim');
  function closeAll(){
    $$('.panel').forEach(function(p){p.classList.remove('on')});
    var s=$('#srch'); if(s)s.classList.remove('on');
    if(scrim)scrim.classList.remove('on');
    document.body.style.overflow='';
  }
  function openPanel(sel){
    var d=$(sel); if(!d)return;
    closeAll(); d.classList.add('on');
    if(scrim)scrim.classList.add('on');
    document.body.style.overflow='hidden';
  }
  if(scrim)scrim.addEventListener('click',closeAll);
  document.addEventListener('click',function(e){if(e.target.closest('[data-close]'))closeAll()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll()});
  var mb=$('#wkMenuBtn'); if(mb)mb.addEventListener('click',function(){openPanel('#menuPanel')});

  var sb=$('#wkSearchBtn');
  if(sb)sb.addEventListener('click',function(){
    var s=$('#srch'); if(!s)return;
    closeAll(); s.classList.add('on'); document.body.style.overflow='hidden';
    var i=$('#srchInput'); if(i)i.focus();
  });

  var si=$('#srchInput');
  if(si){
    var tmr;
    si.addEventListener('input',function(){
      clearTimeout(tmr);
      var q=si.value.trim();
      var res=$('#srchRes'), hint=$('#srchHint');
      if(q.length<2){if(res)res.innerHTML='';if(hint)hint.textContent='Escribe para buscar en el catálogo';return}
      tmr=setTimeout(function(){
        fetch(R.predictive+'?q='+encodeURIComponent(q)+'&resources[type]=product,article&resources[limit]=8&section_id=predictive-search')
          .then(function(r){return r.text()})
          .then(function(html){
            var doc=new DOMParser().parseFromString(html,'text/html');
            var items=doc.querySelectorAll('[data-sr]');
            if(!res)return;
            if(!items.length){res.innerHTML='';if(hint)hint.textContent='Sin resultados para "'+q+'"';return}
            if(hint)hint.textContent=items.length+' resultado(s)';
            res.innerHTML=''; items.forEach(function(i){res.appendChild(i)});
          })
          .catch(function(){ if(hint)hint.textContent='Presiona Enter para buscar "'+q+'"' });
      },220);
    });
  }

  function refreshCart(){
    return fetch(R.cart+'?section_id=cart-drawer',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.text()})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('#cartPanel');
        var cur=$('#cartPanel');
        if(fresh&&cur){
          var body=fresh.querySelector('#cartBody'), foot=fresh.querySelector('.panel-foot'), n=fresh.querySelector('#cartN');
          if(body)cur.querySelector('#cartBody').innerHTML=body.innerHTML;
          if(foot)cur.querySelector('.panel-foot').innerHTML=foot.innerHTML;
          if(n)$$('[data-cart-count]').forEach(function(b){b.textContent=n.textContent.trim()});
        }
      })
      .catch(function(){});
  }
  function cartCount(){
    return fetch(R.cart+'.js').then(function(r){return r.json()}).then(function(c){
      $$('[data-cart-count]').forEach(function(b){b.textContent=c.item_count});
      var n=$('#cartN'); if(n)n.textContent=c.item_count;
      return c;
    });
  }

  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action*="/cart/add"]');
    if(!form||!$('#cartPanel'))return;
    e.preventDefault();
    var btn=form.querySelector('[data-add]'), txt=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Agregando...'}
    fetch(R.add+'.js',{method:'POST',body:new FormData(form)})
      .then(function(r){return r.json()})
      .then(function(){return refreshCart()})
      .then(function(){return cartCount()})
      .then(function(){openPanel('#cartPanel')})
      .catch(function(){form.submit()})
      .finally(function(){if(btn){btn.disabled=false;btn.textContent=txt}});
  });

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-line-qty]'); if(!b)return;
    e.preventDefault();
    var line=b.getAttribute('data-line-qty'), to=b.getAttribute('data-to');
    fetch(R.change+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+line,quantity:+to})})
      .then(function(r){return r.json()})
      .then(function(){
        if(document.body.classList.contains('template-cart')){location.reload();return}
        return refreshCart().then(cartCount);
      })
      .catch(function(){location.reload()});
  });

  $$('[data-pdp]').forEach(function(pdp){
    var main=pdp.querySelector('[data-gal-main]');
    var count=pdp.querySelector('[data-gal-count]');
    var thumbs=$$('[data-gal-thumb]',pdp);
    var i=0;
    function show(n){
      i=(n+thumbs.length)%thumbs.length;
      thumbs.forEach(function(t,ix){t.classList.toggle('on',ix===i)});
      var src=thumbs[i].getAttribute('data-src');
      if(main&&src)main.setAttribute('src',src);
      if(count)count.textContent=(i+1)+' / '+thumbs.length;
    }
    thumbs.forEach(function(t,ix){t.addEventListener('click',function(){show(ix)})});
    var p=pdp.querySelector('[data-gal-prev]'), n=pdp.querySelector('[data-gal-next]');
    if(p)p.addEventListener('click',function(){show(i-1)});
    if(n)n.addEventListener('click',function(){show(i+1)});
    if(thumbs.length)show(0);

    var data=pdp.querySelector('[data-variants]');
    if(!data)return;
    var variants=JSON.parse(data.textContent||'[]');
    var idInput=pdp.querySelector('[data-variant-id]');
    var priceEl=pdp.querySelector('[data-price]');
    var addBtn=pdp.querySelector('[data-add]');
    var note=pdp.querySelector('[data-stock-note]');
    function selected(){
      return $$('[data-option-index]',pdp).map(function(group){
        var on=group.querySelector('input:checked');
        return on?on.value:null;
      });
    }
    function match(){
      var s=selected(), found=null;
      variants.forEach(function(v){
        if(found)return;
        var ok=true;
        s.forEach(function(val,ix){ if(val!==null && v.options[ix]!==val) ok=false });
        if(ok)found=v;
      });
      return found;
    }
    function update(){
      var v=match();
      if(!v)return;
      if(idInput)idInput.value=v.id;
      if(priceEl)priceEl.textContent=v.price;
      if(addBtn){
        addBtn.disabled=!v.available;
        addBtn.textContent=v.available?'Añadir al carro':'Sin stock';
      }
      if(note)note.textContent=v.available?'En stock · despacho en 24 h hábiles':'Agotado en esta combinación';
      if(history.replaceState)history.replaceState({},'',window.location.pathname+'?variant='+v.id);
    }
    $$('[data-option-index] input',pdp).forEach(function(inp){inp.addEventListener('change',update)});
    update();
  });

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]'); if(!b)return;
    var inp=b.parentNode.querySelector('input');
    if(!inp)return;
    var v=parseInt(inp.value||'1',10)+parseInt(b.getAttribute('data-qty'),10);
    inp.value=Math.max(1,Math.min(99,v));
  });

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wish]'); if(!b)return;
    b.classList.toggle('on');
    b.innerHTML=b.classList.contains('on')?'&#9829;':'&#9825;';
  });

  syncArrows();
})();
